/* NORAH · Automatic free gift.
   When the cart has at least NR_GIFT.min units of other products, the gift product is added
   (1 unit, line property _nr_gift). When it drops below, the gift line is removed.
   The price becomes 0 through the automatic "Buy X get Y" discount at checkout.
   Config comes from the footer section "NORAH · Brinde automático". */
(function () {
  var cfg = window.NR_GIFT;
  if (!cfg || !cfg.enabled || !cfg.variant || !cfg.product) return;
  if (window.nrGiftBoot) return;
  window.nrGiftBoot = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var again = false;
  var timer;
  var nativeFetch = window.fetch.bind(window);

  function isGift(item) {
    return item.product_id === cfg.product && item.properties && item.properties._nr_gift;
  }

  function post(path, body) {
    body.sections = ['cart-drawer', 'cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-NR-Gift': '1' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function refresh(res) {
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    if (!res || !res.sections) return;
    var cd = document.querySelector('cart-drawer');
    var parser = new DOMParser();
    if (cd && res.sections['cart-drawer']) {
      var doc = parser.parseFromString(res.sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var current = document.getElementById('CartDrawer');
      if (fresh && current) {
        current.innerHTML = fresh.innerHTML;
        var empty = doc.querySelector('cart-drawer');
        if (empty) cd.classList.toggle('is-empty', empty.classList.contains('is-empty'));
        var overlay = cd.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cd.close === 'function') overlay.addEventListener('click', cd.close.bind(cd));
      }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && res.sections['cart-icon-bubble']) {
      var b = parser.parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
  }

  function sync() {
    if (busy) { again = true; return; }
    busy = true;
    nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;
        var gifts = [];
        cart.items.forEach(function (item) {
          if (isGift(item)) { gifts.push(item); return; }
          if (item.product_id === cfg.product) return;
          count += item.quantity;
        });
        if (count >= cfg.min) {
          if (gifts.length === 0) {
            return post('cart/add.js', { items: [{ id: cfg.variant, quantity: 1, properties: { _nr_gift: cfg.label || 'Free gift' } }] });
          }
          if (gifts[0].quantity !== 1 || gifts.length > 1) {
            var updates = {};
            gifts.forEach(function (g, i) { updates[g.key] = i === 0 ? 1 : 0; });
            return post('cart/update.js', { updates: updates });
          }
          return null;
        }
        if (gifts.length) {
          var rm = {};
          gifts.forEach(function (g) { rm[g.key] = 0; });
          return post('cart/update.js', { updates: rm });
        }
        return null;
      })
      .then(function (res) { if (res) refresh(res); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 350);
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var mine = init && init.headers && (init.headers['X-NR-Gift'] || (init.headers.get && init.headers.get('X-NR-Gift')));
    var p = nativeFetch(input, init);
    if (!mine && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(schedule, schedule);
    }
    return p;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
